// Identifies a candidate for the team_profiles/resume_pdf endpoint.
//
// Saved candidates are found by profileId. Recommendations don't have one — they live in a
// per-project Redis cache keyed by tfId, so the project has to come along for the backend to
// find them.
//
// preferTfId is set in the recs tab. A recommendation can carry a Pensieve profileId while
// still being invisible to this team, and the profileId branch resolves through
// profile_visible?, which 404s in exactly that case. Keying on tfId there also means the
// single export renders from the same source as the bulk recs export.
export default function resumePdfParams(candidate, currentProject, { preferTfId = false } = {}) {
  const useTfId = candidate?.tfId ? preferTfId || !candidate?.profileId : false;
  const params = useTfId
    ? { tfId: candidate.tfId }
    : { profileId: candidate?.profileId };

  if (currentProject?.id) {
    params.projectId = currentProject.id;
  }

  return params;
}
